module.exports = __webpack_public_path__ + "prod/20260714105240/img/url-app.d88da72d.png";